import DeliveryQualityInspection from '@/models/DeliveryQualityInspection/DeliveryQualityInspection';

export default class DeliveryQualityInspectionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryQualityInspectionNo = '';
		this.deliveryInstructionId  = '';
		this.deliveryInstructionDiNumber = '';
		this.deliveryQualityInspectionStatusId  = '';
		this.deliveryQualityInspectionStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryQualityInspectionNo : '0',
			deliveryInstructionId : '0',
			deliveryInstructionDiNumber : '0',
			deliveryQualityInspectionStatusId : '0',
			deliveryQualityInspectionStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}